'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderMarkdown = exports.resetMarkdownCache = undefined;

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _verify = require('helpers/verify');

var _marked = require('./marked');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Here, we override renderers for markdown tokens we do not want to support.

  See https://github.com/markedjs/marked/blob/master/docs/USING_PRO.md for the full list of
  token renderers, and their arguments.
*/

var renderer = new _marked.marked.Renderer();

/* Block Level */
renderer.code = function () {
  return '';
};
renderer.blockquote = function () {
  return '';
};
renderer.html = function () {
  return '';
};
renderer.heading = function () {
  return '';
};
renderer.hr = function () {
  return '';
};
renderer.table = function () {
  return '';
};
renderer.tablerow = function () {
  return '';
};
renderer.tablecell = function () {
  return '';
};
renderer.paragraph = function (text) {
  return (/\n/m.test(text) ? '<p>' + text + '</p>' : text
  );
}; // Don't wrap single-line strings in a <p>

/* Inline Level */
renderer.codespan = function () {
  return '';
};
renderer.link = function () {
  return '';
};
renderer.image = function () {
  return '';
};

var options = {
  renderer: renderer,
  sanitize: true,
  smartypants: true
};

var cache = new _map2.default();
var resetMarkdownCache = exports.resetMarkdownCache = function resetMarkdownCache(key) {
  return key ? cache.delete(key) : cache.clear();
};

var parseMarkdown = function parseMarkdown(md, key) {
  if (__SERVER__) {
    // We don't cache markdown renders on the server,
    // since Map is shared across requests.
    return (0, _marked.marked)(md, options);
  }

  if (key && cache.has(key)) {
    return cache.get(key);
  }

  var parsed = (0, _marked.marked)(md, options);

  if (key) {
    cache.set(key, parsed);
  }

  return parsed;
};

// This data is controlled by us, and marked sanitizes HTML. So we can "safely" use dangerouslySet here.
// eslint-disable-next-line react/no-danger
var renderMarkdown = exports.renderMarkdown = function renderMarkdown(md, key) {
  return typeof md === 'string' && !(0, _verify.isBlank)(md) ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: parseMarkdown(md, key) } }) : null;
};